import { z } from 'zod';
import { RequestTaskTab } from './-constants';
export const SearchSchema = z.object({
  taskTab: z.nativeEnum(RequestTaskTab).default(RequestTaskTab.NOT_SUBMITTED).catch(RequestTaskTab.NOT_SUBMITTED),
  page: z.number().int().min(1).default(1).catch(1),
  pageSize: z.number().int().min(1).default(20).catch(20)
});